import React from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";
import { RootState } from "store";

import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import TableBody from "@mui/material/TableBody";
import StyledTableRow from "app/Components/Tables/StyledTableRow";
import StyledTableCell from "app/Components/Tables/StyledTableCell";
import Paper from "@mui/material/Paper";

import { CSVLink } from "react-csv";

import PlayerSessionsHeader from "./PlayerSessionsHeader";

interface PlayerSession {
  id: string;
  playerName: string;
  startedAt: number;
  endedAt?: number;
  gameName: string;
}

const useStyles = makeStyles({
  Button: {
    width: "90%",
    color: "white",
    backgroundColor: "teal",
    padding: "12px",
    border: "none",
    cursor: "pointer",
    textDecoration: "none",
  },
});

const RenderPlayTime = (
  endTime: number,
  startTime: number,
): React.ReactElement => {
  const MillisecondsPerSec = 1000;
  const SecsPerMin = 60;

  const playTimeinSecs = (endTime - startTime) / MillisecondsPerSec;
  const playTimeInMinutes =
    (endTime - startTime) / (SecsPerMin * MillisecondsPerSec);
  const seconds = Math.floor(playTimeinSecs % 60);
  const hours = Math.floor(playTimeInMinutes / 60);
  const minutes = Math.floor(playTimeInMinutes % 60);

  return (
    <div>
      {hours}hrs {minutes}mins {seconds}s
    </div>
  );
};

const renderTableBody = (
  playerSessions: PlayerSession[],
): React.ReactElement => (
  <TableBody>
    {playerSessions.map((sale: PlayerSession) => {
      let { id, playerName, startedAt, endedAt, gameName } = sale;
      if (!endedAt) endedAt = Date.now();
      const startTimeString = new Date(startedAt).toString().split("GMT")[0];
      const endTimeString = new Date(endedAt).toString().split("GMT")[0];

      return (
        <StyledTableRow key={id}>
          <StyledTableCell align="center">{playerName}</StyledTableCell>
          <StyledTableCell align="center">{gameName}</StyledTableCell>
          <StyledTableCell align="center">{startTimeString}</StyledTableCell>
          <StyledTableCell align="center">{endTimeString}</StyledTableCell>
          <StyledTableCell align="center">
            {RenderPlayTime(endedAt, startedAt)}
          </StyledTableCell>
        </StyledTableRow>
      );
    })}
  </TableBody>
);

const PlayerSessionTable = (): React.ReactElement => {
  const classes = useStyles();
  const filteredPlayerSessions = useSelector(
    (state: RootState) => state.sessions.filteredPlayerSessions,
  ) as PlayerSession[];
  const fetched = useSelector(
    (state: RootState) => state.sessions.fetchedPlayerSessions,
  );

  return (
    <div>
      {fetched ? (
        <>
          <CSVLink
            data={filteredPlayerSessions}
            filename="PlayerSessions.csv"
            className={classes.Button}
          >
            Download Player Sessions
          </CSVLink>
          <br />
          <br />

          <TableContainer component={Paper}>
            {filteredPlayerSessions.length === 0 ? (
              <>No Sessions Found</>
            ) : (
              <Table aria-label="customized table">
                {PlayerSessionsHeader()}
                {renderTableBody(filteredPlayerSessions)}
              </Table>
            )}
          </TableContainer>
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default PlayerSessionTable;
